module.exports = __webpack_public_path__ + "static/media/featureIconFive.7fc10d0d.webp";